import { useTranslation } from 'react-i18next';
import { TApproveSuggestedFaqInput } from '@/models/suggestedFaq.model';
import { useAppDispatch, useAppState } from '@/store';
import { approveSuggestedFaq, rejectSuggestedFaq, selectSuggestedFaqDetailsIsLoading } from '../feature';
import { showSuccessToast } from '@/components';
import { ApproveSuggestedFaqDTO, RejectSuggestedFaqDTO } from '../dtos';

export const useChangeSuggestedFaqStatus = (reviewId?: string) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const isLoading = useAppState(selectSuggestedFaqDetailsIsLoading);

  const handleApproveSuggestedFaq = async (data: TApproveSuggestedFaqInput) => {
    if (!reviewId) return;
    await dispatch(approveSuggestedFaq(new ApproveSuggestedFaqDTO({ reviewId, ...data }))).unwrap();
    showSuccessToast({ message: t('suggested_faq_approved_message') });
  };

  const handleRejectSuggestedFaq = async () => {
    if (!reviewId) return;
    await dispatch(rejectSuggestedFaq(new RejectSuggestedFaqDTO({ reviewId }))).unwrap();
    showSuccessToast({ message: t('suggested_faq_rejected_message') });
  };

  return { handleApproveSuggestedFaq, handleRejectSuggestedFaq, isLoading };
};
